<script>

import Business from '@/services/Business';

import General from '@/services/General';

import Multiselect from 'vue-multiselect';

import Swal from 'sweetalert2';

import _ from 'underscore';



const emptyPerson = () => ({

  first_name: '',

  name_prefix: '',

  last_name: '',

  email: '',

});



export default {

  components: {

    Multiselect,

  },

  props: {

    eventId: {

      type: String,

      default: '',

    },

    eventData: {

      type: Object,

      default: () => ({}),

    },

    registeredCustomerIds: {

      type: Array,

      default: () => [],

    },

  },

  data() {

    return {

      showModal: false,

      tryingToSubmit: false,

      isLoading: false,

      customerData: [],

      errorMessage: '',

      form: {

        registrant: null,

        customer_id: '',

        peopleCount: 1,

        people: [emptyPerson()],

        fieldValues: {},

      },

    };

  },

  computed: {

    activeEventFields() {

      const fields = this.eventData?.event_info?.event_fields || [];

      return fields.filter((f) => f.active === 1 || f.active === '1');

    },

    remainingSeats() {

      const seats = this.eventData?.event_info?.remainingSeats;

      return seats !== null && seats !== undefined && seats !== '' ? Number(seats) : null;

    },

    userLimit() {

      const limit = this.eventData?.userLimit ?? this.eventData?.event_info?.userLimit;

      return limit !== null && limit !== undefined && limit !== '' ? Number(limit) : null;

    },

    maxPeopleCount() {

      const limits = [];

      if (this.remainingSeats !== null && !isNaN(this.remainingSeats)) {

        limits.push(this.remainingSeats);

      }

      if (this.userLimit !== null && !isNaN(this.userLimit)) {

        limits.push(this.userLimit);

      }

      if (!limits.length) return null;

      return Math.min(...limits);

    },

    limitedSpaceWarning() {

      return this.remainingSeats !== null && this.remainingSeats <= 5;

    },

  },

  watch: {

    'form.registrant'(selected) {

      if (selected && selected.id) {

        this.form.customer_id = selected.id;

        this.syncRegistrantToPersonOne();

      } else {

        this.form.customer_id = '';

      }

    },

    'form.peopleCount'(count) {

      this.syncPeopleArray(count);

    },

  },

  methods: {

    personLabel(index) {

      return index === 0 ? 'Person 1 (registrant)' : `Person ${index + 1}`;

    },



    syncPeopleArray(count) {

      const size = Math.max(1, parseInt(count, 10) || 1);

      const current = this.form.people || [];

      const next = [];

      for (let i = 0; i < size; i += 1) {

        next.push(current[i] ? { ...current[i] } : emptyPerson());

      }

      this.form.people = next;

      this.syncRegistrantToPersonOne();

    },



    syncRegistrantToPersonOne() {

      if (!this.form.registrant || !this.form.people.length) {

        return;

      }

      const person = this.form.people[0];

      person.first_name = this.form.registrant.name || person.first_name || '';

      person.last_name = this.form.registrant.surname || person.last_name || '';

      person.email = this.form.registrant.text || person.email || '';

    },



    getCustomersAutocomplete: _.debounce(async function (query) {

      this.customerData = [];

      if (!query || query.length < 2) return;



      this.isLoading = true;

      try {

        const response = await General.autocomplete({

          table: 'business_user',

          column: 'email',

          filter: `${query}`,

          select: ['customer_id', 'email', 'name', 'surname'],

        });

        const registered = new Set(this.registeredCustomerIds.map(String));

        this.customerData = (response.data?.data || [])

          .filter((item) => item.customer_id && !registered.has(String(item.customer_id)))

          .map((item) => ({

            text: item.email,

            id: item.customer_id,

            name: item.name || '',

            surname: item.surname || '',

          }))

          .filter(

            (value, index, self) =>

              self.findIndex((x) => x.id === value.id) === index

          );

      } catch (error) {

        console.error('Error fetching customers:', error);

        this.customerData = [];

      } finally {

        this.isLoading = false;

      }

    }, 400),



    decrementPeopleCount() {

      if (this.form.peopleCount > 1) {

        this.form.peopleCount -= 1;

      }

    },



    incrementPeopleCount() {

      const max = this.maxPeopleCount;

      if (max === null || this.form.peopleCount < max) {

        this.form.peopleCount += 1;

      }

    },



    initFieldValues() {

      const values = {};

      this.activeEventFields.forEach((field) => {

        values[field.id] = '';

      });

      this.form.fieldValues = values;

    },



    resetForm() {

      this.errorMessage = '';

      this.customerData = [];

      this.form.registrant = null;

      this.form.customer_id = '';

      this.form.peopleCount = 1;

      this.form.people = [emptyPerson()];

      this.initFieldValues();

    },



    onShown() {

      this.resetForm();

    },



    buildPersonName(person) {

      return [person.first_name, person.name_prefix, person.last_name]

        .map((part) => String(part || '').trim())

        .filter(Boolean)

        .join(' ');

    },



    buildAttendeesPayload() {

      return this.form.people.map((person) => ({

        email: String(person.email || '').trim(),

        name: this.buildPersonName(person),

      }));

    },



    buildFieldsPayload() {

      const fields = {};

      this.activeEventFields.forEach((field) => {

        const value = this.form.fieldValues[field.id];

        if (value !== null && value !== undefined && String(value).trim() !== '') {

          fields[field.id] = value;

        }

      });

      return fields;

    },



    validatePeople() {

      for (let i = 0; i < this.form.people.length; i += 1) {

        const person = this.form.people[i];

        const label = this.personLabel(i);

        if (!String(person.first_name || '').trim()) {

          this.errorMessage = `${label}: first name is required.`;

          return false;

        }

        if (!String(person.last_name || '').trim()) {

          this.errorMessage = `${label}: last name is required.`;

          return false;

        }

        if (!String(person.email || '').trim()) {

          this.errorMessage = `${label}: email is required.`;

          return false;

        }

      }

      return true;

    },



    async submitRegistration() {

      if (!this.eventId) {

        this.errorMessage = 'Event ID is missing.';

        return;

      }

      if (!this.form.customer_id) {

        this.errorMessage = 'Please select the registrant (business user).';

        return;

      }

      if (!this.validatePeople()) {

        return;

      }



      const reservation = parseInt(this.form.peopleCount, 10);

      if (isNaN(reservation) || reservation < 1) {

        this.errorMessage = 'Amount of people must be at least 1.';

        return;

      }

      if (this.form.people.length !== reservation) {

        this.errorMessage = 'Person details must match the selected amount of people.';

        return;

      }

      if (this.maxPeopleCount !== null && reservation > this.maxPeopleCount) {

        this.errorMessage = `Maximum allowed: ${this.maxPeopleCount} ticket(s) per registration.`;

        return;

      }



      for (const field of this.activeEventFields) {

        const isRequired = field.is_required === 1 || field.is_required === '1';

        const value = this.form.fieldValues[field.id];

        if (isRequired && (!value || String(value).trim() === '')) {

          const label = field.label || field.name || 'Field';

          this.errorMessage = `Please fill in required field: ${label}`;

          return;

        }

      }



      this.tryingToSubmit = true;

      this.errorMessage = '';



      try {

        const payload = {

          customer_id: this.form.customer_id,

          reservation,

          fields: this.buildFieldsPayload(),

          attendees: this.buildAttendeesPayload(),

        };

        const response = await Business.registerBusinessEventMember(this.eventId, payload);



        if (response.data?.success) {

          Swal.fire('Success', 'Registration added successfully.', 'success');

          this.closeModal();

          this.$emit('onRefresh');

        } else {

          const err = response.data?.error;

          this.errorMessage = Array.isArray(err) ? err.join(', ') : err || 'Registration failed.';

        }

      } catch (error) {

        const err = error.response?.data?.error;

        this.errorMessage = Array.isArray(err) ? err.join(', ') : err || 'Registration failed.';

      } finally {

        this.tryingToSubmit = false;

      }

    },



    closeModal() {

      this.showModal = false;

      this.$bvModal.hide('add_event_attendee');

    },

  },

};

</script>



<template>

  <b-modal

    id="add_event_attendee"

    v-model="showModal"

    title="Add registration"

    title-class="font-18"

    size="lg"

    centered

    scrollable

    @shown="onShown"

    @hidden="resetForm"

  >

    <p v-if="remainingSeats !== null" class="text-muted small mb-2 text-center">

      Remaining seats: <strong>{{ remainingSeats }}</strong>

    </p>

    <p v-if="limitedSpaceWarning" class="text-danger small mb-3 text-center mb-0">

      Limited space available.

    </p>



    <!-- Registrant -->

    <b-form-group label="Registrant (business user) *" label-for="registrant_email">

      <multiselect

        id="registrant_email"

        v-model="form.registrant"

        label="text"

        track-by="id"

        placeholder="Search business user email"

        :options="customerData"

        :multiple="false"

        :searchable="true"

        :loading="isLoading"

        :internal-search="false"

        :clear-on-select="true"

        :close-on-select="true"

        :options-limit="50"

        :max-height="280"

        :show-no-results="true"

        :hide-selected="true"

        @search-change="getCustomersAutocomplete"

      />

    </b-form-group>



    <!-- Amount of people -->

    <div class="d-flex flex-column align-items-center mb-4">

      <label class="fw-semibold mb-2">Amount of people</label>

      <div class="d-flex align-items-center attendee-stepper">

        <b-button

          variant="outline-secondary"

          class="stepper-btn"

          :disabled="form.peopleCount <= 1"

          @click="decrementPeopleCount"

        >

          −

        </b-button>

        <span class="stepper-value mx-3">{{ form.peopleCount }}</span>

        <b-button

          variant="outline-secondary"

          class="stepper-btn"

          :disabled="maxPeopleCount !== null && form.peopleCount >= maxPeopleCount"

          @click="incrementPeopleCount"

        >

          +

        </b-button>

      </div>

      <small v-if="userLimit !== null" class="text-muted mt-1">

        There is a limit of {{ userLimit }} ticket(s) per person.

      </small>

    </div>



    <!-- Per-person details -->

    <div

      v-for="(person, index) in form.people"

      :key="'person_' + index"

      class="person-block mb-4"

    >

      <h6 class="person-block-title">{{ personLabel(index) }}</h6>



      <b-form-group :label="'First name *'" :label-for="'person_first_' + index">

        <b-form-input

          :id="'person_first_' + index"

          v-model="person.first_name"

          placeholder="First name"

        />

      </b-form-group>



      <div class="row">

        <div class="col-md-4">

          <b-form-group :label="'Prefix'" :label-for="'person_prefix_' + index">

            <b-form-input

              :id="'person_prefix_' + index"

              v-model="person.name_prefix"

              placeholder="Prefix"

            />

          </b-form-group>

        </div>

        <div class="col-md-8">

          <b-form-group :label="'Last name *'" :label-for="'person_last_' + index">

            <b-form-input

              :id="'person_last_' + index"

              v-model="person.last_name"

              placeholder="Last name"

            />

          </b-form-group>

        </div>

      </div>



      <b-form-group :label="'Email *'" :label-for="'person_email_' + index">

        <b-form-input

          :id="'person_email_' + index"

          v-model="person.email"

          type="email"

          placeholder="Email address"

        />

      </b-form-group>

    </div>



    <div v-if="activeEventFields.length" class="mt-2">

      <h6 class="mb-3">Registration fields</h6>

      <b-form-group

        v-for="field in activeEventFields"

        :key="field.id"

        :label="(field.label || field.name) + (field.is_required == 1 || field.is_required == '1' ? ' *' : '')"

        :label-for="'field_' + field.id"

      >

        <b-form-input

          :id="'field_' + field.id"

          v-model="form.fieldValues[field.id]"

        />

      </b-form-group>

    </div>



    <p v-if="errorMessage" class="text-danger mt-3 mb-0">{{ errorMessage }}</p>



    <template #modal-footer>

      <b-button variant="light" @click="closeModal">Cancel</b-button>

      <b-button variant="primary" :disabled="tryingToSubmit" @click="submitRegistration">

        <b-spinner v-show="tryingToSubmit" small></b-spinner>

        Sign up

      </b-button>

    </template>

  </b-modal>

</template>



<style scoped>

.attendee-stepper .stepper-btn {

  width: 2.5rem;

  height: 2.5rem;

  padding: 0;

  font-size: 1.25rem;

  line-height: 1;

  font-weight: 600;

}

.attendee-stepper .stepper-value {

  min-width: 2rem;

  text-align: center;

  font-size: 1.25rem;

  font-weight: 600;

}

.person-block {

  border: 1px solid #e9ecef;

  border-radius: 0.5rem;

  padding: 1rem;

  background: #fafafa;

}

.person-block-title {

  font-weight: 600;

  margin-bottom: 1rem;

}

</style>


